import { useEffect } from "react";
import { Dialog } from "primereact/dialog";
import { ProgressBar } from "primereact/progressbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Tag } from "primereact/tag";
import { IDialogParams } from "../api/types/dialog.interface";
import { TDiagnosticParamsInsItem } from "../api/types/diagnostic-dialog.interface";
import { useDiagnosticDevice } from "../hooks/useDiagnosticDevice";
import styles from "./FindDialog.module.css";
import tableStyle from "../../assets/table.module.css";
const getSeverity = (str: string) => {
  switch (str) {
    case "n":
      return "success";
    case "e":
      return "danger";
    case "w":
      return "warning";
    default:
      return "info";
  }
};

const StateTemplate = (item: TDiagnosticParamsInsItem) => {
  return <Tag severity={getSeverity(item.color)} value={item.state}></Tag>;
};

export const DiagnosticDialogModal = ({ show, params }: IDialogParams<any>) => {
  const {
    abort,
    foundedOptions,
    handleCloseDiagnostic,
    progress,
    setDiagnosticData,
    status,
  } = useDiagnosticDevice();

  useEffect(() => {
    setDiagnosticData(params);
  }, [params]);

  return (
    <Dialog
      dismissableMask
      header="Диагностика устройств"
      visible={show}
      onHide={handleCloseDiagnostic}
      style={{ width: 1100 }}
      footer={
        <div style={{ paddingTop: 30, display: "flex", justifyContent: "end" }}>
          <Button
            size="small"
            disabled={status !== "progress"}
            type="button"
            severity="secondary"
            onClick={abort}
            label={"Остановить диагностику"}
          />
        </div>
      }
    >
      <div className={styles.searchForm}>
        <div className={styles.description}>
          Статус диагностики: {params.caption ? params.caption : "—"}
        </div>
        <ProgressBar value={progress} className={styles.description} />
        <div
          className={tableStyle.tableContainer}
          style={{
            padding: 0,
          }}
        >
          <DataTable
            scrollable
            scrollHeight="400px"
            size="small"
            showGridlines
            value={foundedOptions}
            className={tableStyle.table}
            emptyMessage={"Нет результатов диагностики"}
          >
            <Column field="addr" header="Адрес" />
            <Column field="shl" header="Шлейф" />
            <Column field="type" header="Тип устройства" />
            <Column field="acp" header="АЦП" />
            <Column field="voltage" header="Напряжение" />
            <Column field="state" header="Состояние" body={StateTemplate} />
            <Column field="supply" header="Питание" />
            <Column field="signal" header="Сигнал" />
          </DataTable>
        </div>
      </div>
    </Dialog>
  );
};
